import { FC } from "react";
import { TitleWrapper, Wrapper, TextWrapper } from "./NumberBox.styled";
import parse from "html-react-parser";

interface Props {
  data: {
    markup?: string;
    title?: string;
  };
}
const NumberBox: FC<Props> = ({ data }) => {
  const { markup, title } = data;
  return (

      <Wrapper>
        <TitleWrapper>{title}</TitleWrapper>
        <TextWrapper>{markup && parse(markup)}</TextWrapper>
      </Wrapper>

      

  );
};

export default NumberBox;
